import { useNavigate, useRouteLoaderData } from "react-router-dom";
import { useTheme } from "@mui/material";
import { RootLoader } from "@/types/RootLoader";

const useDashboard = () => {
  const appName = "tinyAlbert" as const;
  const theme = useTheme();

  const { accountInfo } = useRouteLoaderData("root") as RootLoader;

  const navigate = useNavigate();

  const navigateTo = (path: string) => {
    navigate(path);
  };

  const config = {
    appName,
    theme,
    baseUrl: import.meta.env.VITE_APP_API_URL || "",
    navigateTo,
    accountId: accountInfo?.id,
    shopifyIntegration: true,
    currency: accountInfo?.currency,
    pageName: "dashboard",
  };
  return { config };
};

export default useDashboard;
